import { PrintType, PrintTypesMap, ProductType } from '@/types';
import { getPrintTypesOfAppearance } from './getPrintTypesOfAppearance';

export const extendPrintTypeData = <CustomProductType extends ProductType = ProductType>(
  productType: CustomProductType,
  printTypes: PrintTypesMap
) => {
  productType.appearances.map((appearance) => {
    const availablePrintTypeIds = new Set(
      getPrintTypesOfAppearance(appearance).map(({ id }) => id)
    );
    const sortedAvailablePrintTypes: PrintType[] = [];
    for (const [printTypeId, printType] of printTypes) {
      if (availablePrintTypeIds.has(printTypeId)) {
        sortedAvailablePrintTypes.push(printType);
      }
    }
    appearance.printTypes = sortedAvailablePrintTypes;
  });
};
